export const SLICE_NAME = 'lunaStreamsStreams';
